import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './indexEventsScreenshot.png';

export const indexEventsDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Index Events widget displays index event information for a
                given symbol. These include additions, deletions, float decrease
                / increase, funding, reinvestment, share increase / decrease,
                weight increase / decrease, buy / sell, reclassification, and
                capping factor changes.
            </div>
        </>
    ),
    previews: [
        {
            title: 'Index Events',
            src: preview,
            altText: 'index-events-widget-preview',
        },
    ],
};
